module.exports = __webpack_public_path__ + "static/media/bg2.631aa5ef.webp";